import PropTypes from 'prop-types';

const VenueTypeIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.99967 1.04199C5.9667 1.04199 2.70801 4.3426 2.70801 8.40087C2.70801 10.7299 3.63669 12.5466 5.41849 14.1256C6.57773 15.1529 8.66013 17.337 9.46602 18.6589C9.57767 18.842 9.77542 18.9551 9.98988 18.9585C10.2043 18.9618 10.4055 18.855 10.5229 18.6754C11.3809 17.3625 13.4328 15.1429 14.5809 14.1256C16.3627 12.5466 17.2913 10.7299 17.2913 8.40087C17.2913 4.3426 14.0326 1.04199 9.99967 1.04199ZM9.99967 4.58366L11.3122 6.83366L13.7497 7.4484L12.0622 9.27116L12.6923 12.0837L9.99967 10.9587L7.30705 12.0837L7.93717 9.27116L6.24967 7.4484L8.68717 6.83366L9.99967 4.58366Z'
        fill='#1E1E1E'
      />
    </svg>
  );
};

VenueTypeIcon.propTypes = {
  className: PropTypes.string,
};

export default VenueTypeIcon;
